require('normalize.css/normalize.css');

import React from 'react';
import Grid from './Grid';
import Footer from './Footer';
import Tab from './Tab';
import $ from 'jquery';

class AppComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      images: null,
      currentType: null,
      width: window.innerWidth-20
    };
    fetch('images/portfolio.json')
      .then( response => response.json() )
      .then( obj => this.setState({images: obj}));

    this.updateDimensions = this.updateDimensions.bind(this);
  }

  scrollHome() {
    $('html, body').animate({
      scrollTop: 0
    }, 500);
  }

  scrollToComntact() {
    $('html, body').animate({
      scrollTop: $(document).height()-$(window).height()
    }, 500);
  }

  updateDimensions() {
    this.setState({
      width: window.innerWidth-20
    });
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  render() {
    if (this.state.images) {
      return (
        <div>
          <div
            className="header"
            style={{
              width: this.state.width < 800 ? this.state.width : 800
            }}
          >
            <div className="tabs">
              <Tab active = {this.state.currentType} name = 'graphic' />
              <Tab active = {this.state.currentType} name = 'design'  />
              <Tab active = {this.state.currentType} name = 'interior' />
              <Tab active = {this.state.currentType} name = 'painting' />
            </div>
            <div className="mano">
              <img
                src={require('../icons/mano.png')}
                onClick = {this.scrollHome.bind(this)}
              />
            </div>
            <div className="contact">
              <img
                src={require('../icons/contact.png')}
                onClick = {this.scrollToComntact.bind(this)}
              />
            </div>
          </div>
          <div ref='grid' className="grid-container">
            <Grid
              images={this.state.images}
              width={this.state.width}
              onTypeChange = {t => this.setState({currentType: t})}
            />
          </div>
          <Footer />
        </div>
      );
    }
    else
      return null;
  }
}

AppComponent.defaultProps = {
};

export default AppComponent;



// WEBPACK FOOTER //
// ./src/components/Main.js